module.exports = __webpack_public_path__ + "img/shipblu-shields.4097b693.svg";